/**
 * Единые брейкпоинты для адаптива.
 * В CSS те же значения заданы в :root как --bp-sm, --bp-md, --bp-lg (main.css).
 */
export const BREAKPOINTS = {
  sm: 600,
  md: 960,
  lg: 1200,
  xl: 1260,
} as const

export type BreakpointKey = keyof typeof BREAKPOINTS
